import Footer from "./footer.container";

export default Footer;